import React from 'react';

const GroupSidebar = () => {
  const onDragStart = (event, nodeType) => {
    event.dataTransfer.setData('application/reactflow', nodeType);
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <aside style={{ width: 200, padding: 10, background: '#f0f0f0' }}>
      {/* <div style={{ marginBottom: 10, fontWeight: 'bold' }}>Palettes</div> */}
      <div
        onDragStart={(event) => onDragStart(event, 'area')}
        draggable
        style={{ marginBottom: 10, padding: 10, background: '#E3F2FD', cursor: 'grab' }}
      >
        ➤ Area
      </div>
      <div
        onDragStart={(event) => onDragStart(event, 'cluster')}
        draggable
        style={{ marginBottom: 10, padding: 10, background: '#E8F5E9', cursor: 'grab' }}
      >
        ➤ Cluster
      </div>
      <div
        onDragStart={(event) => onDragStart(event, 'location')}
        draggable
        style={{ marginBottom: 10, padding: 10, background: '#FFF3E0', cursor: 'grab' }}
      >
        ➤ Location
      </div>
      <div
        onDragStart={(event) => onDragStart(event, 'outlet')}
        draggable
        style={{ marginBottom: 10, padding: 10, background: '#FCE4EC', cursor: 'grab' }}
      >
        ➤ Outlet
      </div>

      <div style={{ marginTop: 20, borderTop: '1px solid #ccc', paddingTop: 10, fontSize: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
          <span
            style={{ color: 'blue' }}
          >
            ✎
          </span>&nbsp;- Edit Node Title
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 6 }}>
          <span
            style={{ color: 'red' }}
          > X </span>&nbsp; - Delete Node
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <span
            style={{ color: 'grey' }}
          ><i className="ri-arrow-right-line"></i> </span>&nbsp;- Click for Delete Edge
        </div>
      </div>
    </aside>
  );
};

export default GroupSidebar;
